var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var AudioRecorderManager = /** @class */ (function () {
    function AudioRecorderManager(canvasId, onRecordingStopped) {
        var _this = this;
        this.mediaRecorder = null;
        this.audioChunks = [];
        this.stream = null;
        this.analyser = null;
        this.dataArray = null;
        this.bufferLength = null;
        this.canvasId = canvasId;
        this.onRecordingStopped = onRecordingStopped;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, audioCtx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                audio: true,
                            })];
                    case 1:
                        _a.stream = _b.sent();
                        audioCtx = new AudioContext();
                        this.analyser = audioCtx.createAnalyser();
                        this.analyser.fftSize = 2048;
                        this.bufferLength = this.analyser.frequencyBinCount;
                        this.dataArray = new Uint8Array(this.bufferLength);
                        this.source = audioCtx.createMediaStreamSource(this.stream);
                        this.source.connect(this.analyser);
                        this.drawSoundWave();
                        return [2 /*return*/];
                }
            });
        }); })();
    }
    AudioRecorderManager.prototype.drawSoundWave = function () {
        var self = this;
        var canvas = document.getElementById(this.canvasId);
        // if(!canvas)
        //     return;
        var WIDTH = canvas.width;
        var HEIGHT = canvas.height;
        var ctx = canvas.getContext("2d");
        var sliceWidth = WIDTH / this.bufferLength;
        function draw() {
            self.analyser.getByteTimeDomainData(self.dataArray);
            var x = 0;
            ctx.lineWidth = 3;
            ctx.strokeStyle = "#8426df";
            ctx.clearRect(0, 0, WIDTH, HEIGHT);
            ctx.beginPath();
            for (var i = 0; i < self.bufferLength; i++) {
                var v = self.dataArray[i] / 128.0;
                var y = v * (HEIGHT / 2);
                if (i === 0) {
                    ctx.moveTo(x, y);
                }
                else {
                    ctx.lineTo(x, y);
                }
                x += sliceWidth;
            }
            ctx.lineTo(WIDTH, HEIGHT / 2);
            ctx.stroke();
            var drawVisual = requestAnimationFrame(draw);
        }
        draw();
    };
    AudioRecorderManager.prototype.startRecording = function () {
        var _this = this;
        this.mediaRecorder = new MediaRecorder(this.stream);
        this.mediaRecorder.ondataavailable = function (event) {
            if (event.data.size > 0) {
                _this.audioChunks.push(event.data);
            }
        };
        this.mediaRecorder.onstop = function () {
            var audioBlob = new Blob(_this.audioChunks, { type: "audio/wav" });
            var audioUrl = URL.createObjectURL(audioBlob);
            _this.onRecordingStopped(audioBlob);
        };
        this.mediaRecorder.start();
    };
    AudioRecorderManager.prototype.stopRecording = function () {
        if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
            this.mediaRecorder.stop();
        }
    };
    AudioRecorderManager.prototype.createDownloadLink = function (audioBlob) {
        var downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(audioBlob);
        downloadLink.download = "recorded_audio.wav";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    return AudioRecorderManager;
}());
export { AudioRecorderManager };
// document.addEventListener("DOMContentLoaded", () => {
//     // let permission = confirm("permission to use mic?");
//     // if (permission) {
//     new AudioRecorder();
//     // }
// });
